import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProgressBarContainer = styled.div`
  display: flex;
  width: ${({ $small }) => ($small ? '160px' : '480px')};
  justify-content: flex-start;
  background-color: var(--gray-8);
  border-radius: ${({ $small }) => ($small ? '3px' : '4px')};
  height: ${({ $small }) => ($small ? '6px' : '8px')};
  overflow: hidden;
`;

const ProgressTrack = styled.div`
  width: ${({ $progress, $total }) => `${($progress / $total) * 100}%`};
  height: 100%;
  border-radius: ${({ $small }) => ($small ? '2px' : '4px')};
  background-color: var(--orange-100);

  transition: width 0.2s ease-in-out;
`;

const ProgressBar = ({ progress, total = 100, small = false }) => (
  <ProgressBarContainer $small={small}>
    <ProgressTrack $progress={progress} $total={total} $small={small} />
  </ProgressBarContainer>
);

ProgressBar.propTypes = {
  small: PropTypes.bool,
  progress: PropTypes.number.isRequired,
  total: PropTypes.number
};

export { ProgressBar };
